import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import "../../assets/css/admin/editPackage.css";

import { db } from "../../firebase/firebase";

import {
    doc,
    getDoc,
    updateDoc
} from "firebase/firestore";

import {
    CLOUDINARY_URL,
    UPLOAD_PRESET
} from "../../services/cloudinary";

function EditPackage() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [title, setTitle] = useState("");

    const [price, setPrice] = useState("");

    const [features, setFeatures] = useState("");

    const [coverPhoto, setCoverPhoto] = useState("");

    const [newImage, setNewImage] = useState(null);

    const [loading, setLoading] = useState(true);

    const [errors, setErrors] = useState({
    title: "",
    price: ""
});

const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

  /*=========================================================
                    LOAD PACKAGE
=========================================================*/

const loadPackage = useCallback(async () => {

    try {

        const docRef = doc(db, "packages", id);

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {

            const data = docSnap.data();

            setTitle(data.title || "");

            setPrice(
                data.price
                    ?.replace("Starting at ₹", "")
                    ?.replace(",", "") || ""
            );

            setCoverPhoto(data.image || "");

            setFeatures(
                data.features
                    ? data.features.join("\n")
                    : ""
            );

        } else {

          setPopup({
    show: true,
    type: "error",
    message: "Package Not Found"
});

setTimeout(() => {

    navigate("/admin/manage-packages");

}, 2000);

        }

    } catch (error) {

        console.log(error);

    setPopup({
    show: true,
    type: "error",
    message: "Failed To Load Package"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

    } finally {

        setLoading(false);

    }

}, [id, navigate]);

useEffect(() => {

    loadPackage();

}, [loadPackage]);

    /*=========================================================
                        IMAGE CHANGE
    =========================================================*/

    const handlePackageImage = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setNewImage(file);

        setCoverPhoto(

            URL.createObjectURL(file)

        );

    };

    /*=========================================================
                    CLOUDINARY IMAGE UPLOAD
    =========================================================*/

    const uploadImage = async () => {

        if (!newImage) {

            return coverPhoto;

        }

        const formData = new FormData();

        formData.append("file", newImage);

        formData.append("upload_preset", UPLOAD_PRESET);

        const response = await fetch(CLOUDINARY_URL, {

            method: "POST",

            body: formData

        });

        const data = await response.json();

        if (!data.secure_url) {

            throw new Error("Cloudinary Upload Failed");

        }

        return data.secure_url;

    };

    /*=========================================================
                        UPDATE PACKAGE
    =========================================================*/

    const savePackage = async () => {

       const validationErrors = {};

if (!title.trim()) {

    validationErrors.title =
        "Package name is required.";

}

if (!price) {

    validationErrors.price =
        "Package price is required.";

}

if (Object.keys(validationErrors).length > 0) {

    setErrors(validationErrors);

    return;

}

setErrors({
    title: "",
    price: ""
});

        try {

            setLoading(true);

            const imageUrl = await uploadImage();

            await updateDoc(doc(db, "packages", id), {

                title,

                price: `Starting at ₹${price}`,

                image: imageUrl,

                features: features
                    .split("\n")
                    .filter(item => item.trim() !== "")

            });

            setPopup({
    show: true,
    type: "success",
    message: "Package Updated Successfully"
});

setTimeout(() => {

    navigate("/admin/manage-packages");

}, 2000);

        }

        catch (error) {

            console.log(error);

            setPopup({
    show: true,
    type: "error",
    message: "Update Failed"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

        finally {

            setLoading(false);

        }

    };

    if (loading) {

        return (

            <div className="edit-package-loading">

                Loading...

            </div>

        );

    }
        return (

            <>{popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success"
                ? "✓"
                : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>{popup.message}</p>

        </div>

    </div>

)}

        <div className="edit-package-page">

            <div className="edit-package-wrapper">

                {/*=====================================================
                                HEADER
                =====================================================*/}

                <div className="edit-package-header">

                    <h1 className="edit-package-title">

                        Edit Premium Package

                    </h1>

                    <p className="edit-package-subtitle">

                        Update your package details, cover image,
                        pricing and package features.

                    </p>

                </div>

                {/*=====================================================
                                FORM CARD
                =====================================================*/}

                <div className="edit-package-card">

                    {/* Cover Image */}

                    <div className="edit-package-field">

                        <label className="edit-package-label">

                            Package Cover Image

                        </label>

                        <input

                            type="file"

                            accept="image/*"

                            className="edit-package-file"

                            onChange={handlePackageImage}

                        />

                    </div>

                    {/* Image Preview */}

                    {

                        coverPhoto && (

                            <div className="edit-package-preview-box">

                                <img

                                    src={coverPhoto}

                                    alt="Package Preview"

                                    className="edit-package-preview-image"

                                />

                            </div>

                        )

                    }

                    {/* Package Name */}

                    <div className="edit-package-field">

                        <label className="edit-package-label">

                            Package Name

                        </label>

                        <input

                            type="text"

                            className="edit-package-input"

                            placeholder="Wedding Photography"

                            value={title}

                            onChange={(e) => {

    setTitle(e.target.value);

    setErrors({
        ...errors,
        title: ""
    });

}}
/>
{errors.title && (

    <p className="validation-error">

        {errors.title}

    </p>

)}

                    </div>

                    {/* Price */}

                    <div className="edit-package-field">

                        <label className="edit-package-label">

                            Starting Price

                        </label>

                        <input

                            type="number"

                            className="edit-package-input"

                            placeholder="25000"

                            value={price}

                            onChange={(e) => {

    setPrice(e.target.value);

    setErrors({
        ...errors,
        price: ""
    });

}}
/>
{errors.price && (

    <p className="validation-error">

        {errors.price}

    </p>

)}
                    </div>

                    {/* Features */}

                    <div className="edit-package-field">

                        <label className="edit-package-label">

                            Package Features

                        </label>

                        <textarea

                            rows={8}

                            className="edit-package-textarea"

                            placeholder={`Enter one feature per line

Example:

Candid Photography
Drone Photography
LED Wall
Live Streaming
Premium Album
2 Photographers
1 Cinematographer
Highlight Video`}

                            value={features}

                            onChange={(e) =>
                                setFeatures(e.target.value)
                            }

                        />

                    </div>

                    {/* Save Button */}

                    <button

                        className="edit-package-save-btn"

                        onClick={savePackage}

                        disabled={loading}

                    >

                        {

                            loading

                                ? "Updating..."

                                : "Save Changes"

                        }

                    </button>

                </div>

            </div>

        </div>
     </>
    );

}

export default EditPackage;